var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "edit-01"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M2.61892 15.2965C2.65721 14.9519 2.67635 14.7796 2.72849 14.6186C2.77474 14.4757 2.84008 14.3398 2.92275 14.2144C3.01594 14.0731 3.13851 13.9505 3.38366 13.7053L14.3889 2.70012C15.3094 1.77965 16.8018 1.77965 17.7222 2.70012C18.6427 3.6206 18.6427 5.11298 17.7222 6.03346L6.717 17.0387C6.47184 17.2838 6.34927 17.4064 6.20796 17.4996C6.0826 17.5823 5.94663 17.6476 5.80376 17.6939C5.64273 17.746 5.47044 17.7651 5.12586 17.8034L2.30556 18.1168L2.61892 15.2965Z",
    stroke: "currentColor",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.3a5324773c73c16408255d4c685bbfae.svg";
export { ForwardRef as ReactComponent };